export const getMonthWithDay = (dateStr: string) => {
    const date = dateStr ? new Date(dateStr) : new Date();
    const month = date.toLocaleString('default', { month: 'short' });
    const day = date.getDate();
    const year = date.getFullYear();

    return {
        month,
        day,
        year,
    };
};

export const getLocalTime = (date: string) => {
    const incomingDate = new Date(date);
    const time = incomingDate.getTime();
    const minutes = time / 1000 / 60;
    const timeZoneInMinutes = new Date().getTimezoneOffset();
    const localMinutes = minutes - timeZoneInMinutes;
    const milliseconds = localMinutes * 60 * 1000;

    return milliseconds;
};

export const updateMonth = (month: number) => {
    const date = new Date();
    const milliseconds = date.setMonth(date.getMonth() + month);
    return milliseconds;
};
